module.exports = __webpack_public_path__ + "img/Z86_03.2b4c9f7c.jpg";